module.exports = __webpack_public_path__ + "media/images/courseware_canvas_courses_icon-fc169a1bc5751ab36064f446605befe0.png";